import type { Person, PersonListSuccess } from "@b2bportal/air-booking-api";
import type { UpdatePassengerEvent } from "@checkout/states/common/PassengerInformation/events";
import { trackCheckoutEvent } from "@checkout/tracking/sink";
import {
  type PartialParentContext,
  PassengerErrorModalTypes,
} from "@checkout/types";
import { fetchUserPassengers, updateUserPassenger } from "@hopper-b2b/api";
import { ADD_PASSPORT } from "@hopper-b2b/types";

import type { UpdatePassportAndContinue } from "../events";

async function preserveExistingPassport(person: Person): Promise<Person> {
  if (person.passport) return person;
  try {
    const response = await fetchUserPassengers({});
    const existing = (response as PersonListSuccess).value?.find(
      (p: Person) => p.id === person.id
    );
    if (existing?.passport) {
      return { ...person, passport: existing.passport };
    }
  } catch (error) {
    console.warn(
      `Failed to fetch existing passport data for preservation (passenger ID: ${person.id}):`,
      error
    );
  }
  return person;
}

export const updatePassengerWithPassportService = (
  _ctx: PartialParentContext,
  event: UpdatePassportAndContinue | UpdatePassengerEvent
) =>
  new Promise((resolve, reject) => {
    const currentPassenger = event.person;

    const { passport: initialPassport, ...restOfPayload } = currentPassenger;
    const personToUpdate: Person = { ...restOfPayload };
    if (currentPassenger.passport?.countryOfIssue?.length === 2) {
      personToUpdate.passport = initialPassport;
    }

    preserveExistingPassport(personToUpdate)
      .then((mergedPerson) => updateUserPassenger({ person: mergedPerson }))
      .then(() => {
        trackCheckoutEvent({
          eventName: ADD_PASSPORT,
          properties: { success: true },
        });
        resolve(null);
      })
      .catch((e) => {
        trackCheckoutEvent({
          eventName: ADD_PASSPORT,
          properties: { success: false },
        });
        reject({
          type: PassengerErrorModalTypes.UpdatePassenger,
          data: e,
        });
      });
  });
